import { render, staticRenderFns } from "./CoveragesForm.vue?vue&type=template&id=523521d1&scoped=true&"
import script from "./CoveragesForm.vue?vue&type=script&lang=js&"
export * from "./CoveragesForm.vue?vue&type=script&lang=js&"
import style0 from "./CoveragesForm.vue?vue&type=style&index=0&id=523521d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523521d1",
  null
  
)

export default component.exports